require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2005-12-12-current-status.json") })
        }
      }, "path---articles-2005-12-12-current-status");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2005-12-12-current-status!./.cache/json/articles-2005-12-12-current-status.json
// module id = 442
// module chunks = 231608221292675